export default __webpack_public_path__ + "./images/eu.8f03a584.png";